import { InjectionToken } from '@angular/core';

export interface AiSessionHostPort {
  isAuthorized(): boolean;
  isLeader(): boolean;
  confirmPassword(): Promise<boolean>;
}

export const AI_SESSION_HOST = new InjectionToken<AiSessionHostPort>('AI_SESSION_HOST');
